/* styles/canvas.js */ function _(require, module, exports) {
    require(62) /* ./root */;
    exports.bk_canvas = "bk-canvas";
    exports.bk_canvas_map = "bk-canvas-map";
    exports.bk_canvas_overlays = "bk-canvas-overlays";
    exports.bk_canvas_events = "bk-canvas-events";
}
